import { useEffect, useState } from 'react';
import API from '../../api';

export default function EtudiantDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    API.get('stats/').then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="loading-screen"><div className="spinner" /><p>Chargement…</p></div>;

  return (
    <div>
      <div className="page-header">
        <h2>Dashboard Étudiant</h2>
        <p>Bienvenue sur votre espace personnel</p>
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue"><i className="bi bi-book" /></div>
          <div className="stat-info"><h3>{stats.cours}</h3><p>Cours</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple"><i className="bi bi-clipboard-check" /></div>
          <div className="stat-info"><h3>{stats.evaluations}</h3><p>Évaluations</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><i className="bi bi-award" /></div>
          <div className="stat-info"><h3>{stats.notes}</h3><p>Notes reçues</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon orange"><i className="bi bi-bell" /></div>
          <div className="stat-info"><h3>{stats.notifications_non_lues}</h3><p>Notifications</p></div>
        </div>
      </div>
    </div>
  );
}
